module.exports = __webpack_public_path__ + "static/Vazir-d28c322f9e3b83d8048808d966fa01c1.eot";